module.exports = __webpack_public_path__ + "media/application/images/home/synagogue-3c0257b34a5eeadd7cfb1830d55f4675.svg";